/* program groups are the landing pages describing: part-time, full-time, summer etc */

import React from "react";

import Layout from "../components/layout";
import PrimaryMenu from "../components/primaryMenu";
import heroStyles from "../components/css/hero.module.scss";
import SubPageNav from '../sections/subPageNav'
import ContentFilterBox from '../sections/contentFilterBox'
import BigLinkBoxes from '../sections/bigLinkBoxes'
import TitledSection from "../sections/titledSection"

import Text from "../sections/text"
import "../components/css/global.scss";

/* sections */
export default function Home({pageContext}) {

  // THIS GETS THE MAIN page data
  let data = pageContext.content.json_data.data; //.content.json_data.data
console.log(data);
  // THIS GETS THE flyoutmenu navigation
  let navigation = pageContext.flyoutnav;

  // THIS GETS THE SUB NAVIGATION
  const subnavName = data.navigation;

  /****** THIS ONE IS CUSTOMED PER PAGE  *****/
  // THIS GETS THE  SUBLINKS FROM THE PAGE JSON
  const programs = data.content.subLinks;


  /**** MOVE TO A FUNCTION FILE  */
  function search(nameKey, myArray){
    for (var i=0; i < myArray.length; i++) {
        if (myArray[i].name === nameKey) {
            return myArray[i];
        }
    }
  }

  let subnav = search(subnavName, navigation).json_data.data.content.subLinks

  data.program = {
    "schools": {
      "local": data.localpathway,
      "international": data.internationalpathway
    }
  };

  return (
    <Layout>
      <div className={heroStyles.heroNoSlide} style={{backgroundImage: "url('http://api.vanarts.com/assets/"+data.cover+"')"}}>
        <PrimaryMenu  navigation={navigation}  />
      </div>
      <SubPageNav title={data.content.title} linksData={subnav}>
        <div dangerouslySetInnerHTML={{__html: data.content.headerintro}}></div>
      </SubPageNav>
       
      <Text>
        <div dangerouslySetInnerHTML={{__html: data.content.bodyintro}}></div>
      </Text>

      <ContentFilterBox filters={["local", "international"]} data={data.program.schools} title="Types of Pathways" cta="Questions about degree pathway options through VanArts?"/>
      
      {
        data.actions.title && 
        <TitledSection title={data.actions.title}>
        <BigLinkBoxes linksData={data.actions.boxes} />
      </TitledSection>
      }
      
    </Layout>
  );
}
